import './services.recaptcha';
import './services.pnotify';
app.directive('formMediaUpload', [
  '$upload',
  '$filter',
  'pnotifyService',
  'mainConfig',
  'RecaptchaService',
  function ($upload, $filter, pnotifyService, mainConfig, RecaptchaService) {
    return {
      restrict: 'E',
      scope: {
        itemId: '@',
        label: '@',
        isRequired: '@',
      },
      require: ['^form'],
      templateUrl: require('../../../../../public/themes/v1/default/views/form.media-upload.html'),
      link: function ($scope, element, attrs, ctrls) {
        $scope.isRecaptchaEnabled = mainConfig.isRecaptchaEnabled;
        $scope.recaptchaId = `upload-media-${$scope.itemId}-recaptcha`;

        var formController = ctrls[0];
        var reset = function () {
          $scope.hasError = false;
          $scope.medias = [];
        };

        reset();
        $scope.$on('form.response.submit', function () {
          reset();
        });

        $scope.$watch(function () {
          return validate();
        });

        $scope.$watch('hasError', function () {
          if ($scope.hasError === true) {
            $scope.errorMessage = $filter('translate')(
              'form.validation.required',
              { field_name: $scope.label },
            );
            return;
          }
        });

        var validate = function () {
          if (
            (formController.$submitted || formController.submitted) &&
            $scope.isRequired === 'true'
          ) {
            $scope.hasError = $scope.medias.length === 0;
            formController.$invalid = $scope.medias.length === 0;
          } else {
            $scope.hasError = false;
          }
        };

        $scope.openFile = function () {
          var input = element.find('input');
          input.trigger('click');
        };

        $scope.deleteMedia = function (media) {
          var index = $scope.medias.indexOf(media);
          $scope.medias.splice(index, 1);
        };

        $scope.onFileSelect = function ($files) {
          $scope.flash = [];
          if ($files.length == 0) {
            pnotifyService.notify(
              $filter('translate')('media.validation.type'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              },
            );
            return;
          }

          if ($files.length > 1) {
            pnotifyService.notify(
              $filter('translate')('media.validation.file_limit.one'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              },
            );
            return;
          }

          $scope.imageUploading = true;

          for (var i = 0; i < $files.length; i++) {
            var file = $files[i];
            $scope.uploadMedia(file);
          }
        };

        $scope.validateMediaRecaptcha = function ($files) {
          if ($files.length === 0) {
            return;
          }
          $scope.tempFiles = $files;
          RecaptchaService.execute($scope.recaptchaId);
        };

        $scope.onMediaRecaptchaSuccess = function () {
          $scope.onFileSelect($scope.tempFiles);
        };

        $scope.onValidateFileSelect = function ($files) {
          if ($scope.isRecaptchaEnabled) {
            $scope.validateMediaRecaptcha($files);
          } else {
            $scope.onFileSelect($files);
          }
        };

        $scope.uploadMedia = function (image) {
          if (image.size / 1024 / 1024 > 5) {
            pnotifyService.notify(
              $filter('translate')('media.validation.error.file_size'),
              {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              },
            );
            $scope.imageUploading = false;
            return;
          }

          $scope.upload = $upload
            .upload({
              url: '/api/media',
              method: 'POST',
              data: {
                media: {
                  status: 'temp',
                },
                recaptchable: true,
              },
              file: image,
              fileFormDataName: 'media[image_clip]',
              formDataAppender: function (fd, key, val) {
                if (angular.isArray(val)) {
                  angular.forEach(val, function (v) {
                    fd.append(key, v);
                  });
                } else if (angular.isObject(val)) {
                  angular.forEach(val, function (value, idx2) {
                    fd.append(key + '[' + idx2 + ']', value);
                  });
                } else {
                  fd.append(key, val);
                }
              },
            })
            .then(function (res) {
              var data = res.data;
              if (data.code === 'INVALID_COLORSPACE') {
                pnotifyService.notify(data.message, {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                });
              } else {
                $scope.medias.push(data.data);
              }
            })
            .catch(function () {
              pnotifyService.notify(
                $filter('translate')('media.validation.error.file_size'),
                {
                  customClass: 'error',
                  icon: 'fa fa-exclamation-triangle',
                },
              );
            })
            .finally(function () {
              $scope.imageUploading = false;
              RecaptchaService.reset($scope.recaptchaId);
            });
        };

        // init Recaptcha
        if ($scope.isRecaptchaEnabled) {
          $scope.recaptchaLoaded = false;
          // Observe the recaptcha SDK readiness via globalSDKObserver instead of
          // a $rootScope flag, so it no longer depends on Angular being bootstrapped
          // (recaptcha loads on document ready, decoupled from angular.bootstrap).
          const unsubscribeRecaptcha = RecaptchaService.waitRecaptchaLoaded(
            function () {
              $scope.$applyAsync(function () {
                $scope.recaptchaLoaded = true;
              });
            },
          );
          $scope.$on('$destroy', function () {
            unsubscribeRecaptcha?.();
          });
          $scope.$watchGroup(
            ['recaptchaLoaded', 'itemId'],
            function (newValue) {
              const [recaptchaLoaded, itemId] = newValue;

              if (recaptchaLoaded && itemId) {
                window[`onMediaRecaptchaSuccess_${itemId}`] = function (token) {
                  $('#g-recaptcha-response').val(token);
                  $scope.onMediaRecaptchaSuccess();
                };
                const sendElement = document.getElementById($scope.recaptchaId);

                if (sendElement && !sendElement.dataset.widgetId) {
                  window.renderSingleRecaptcha(sendElement);
                }
              }
            },
          );
        }
      },
    };
  },
]);
